import { stateTypes, getterTypes } from './landing.moduletypes';

import actions from './landing.moduleactions';
import mutations from './landing.modulemutations';

import LandingApi from '../services/landing.api';

export default {
  // see https://vuex.vuejs.org/guide/modules.html#namespacing
  namespaced: true,

  state: {},
  getters: {
    [getterTypes.LandingApi]: (state, getters, rootState) => {
      // let settings = rootState.applicationState
      //   ? rootState.applicationState.initialSettings
      //   : window.infos.initialSettings;
      return new LandingApi();
    }
  },

  mutations: mutations,

  actions: actions
};
